import moment from "moment";

import axios from "axios";

export function setAuthHeader(token) {
  axios.defaults.headers.common["Authorization"] = token
    ? "Bearer " + token
    : "";
}

export const getCsrfToken = () =>{
  const cookies = document.cookie.split(";");
  for (let cookie of cookies) {
    const [name, value] = cookie.trim().split("=");
    if (name === "XSRF-TOKEN") {
      return value;
    }
  }
  return null;
}

export const getQueryVariable = (variable) => {
  const query = window.location.search.substring(1);
  const vars = query.split("&");
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split("=");
    if (decodeURIComponent(pair[0]) === variable) {
      return decodeURIComponent(pair[1]);
    }
  }
};

export const getBadge = (status) => {
  switch (status) {
    case "Draft":
      return "secondary";
    case "New":
    case "Active":
    case "On-going":
      return "info";
    case "Approved":
    case "Completed":
      return "success";
    case "Inactive":
      return "secondary";
    case "Paid":
      return "success";
    case "Pending":
    case "Unpaid":
      return "warning";
    case "Expired":
      return "danger";
    case "Banned":
    case "Disapproved":
      return "danger";
    default:
      return "primary";
  }
};

// export const randomColor = (index) => {
//   switch (index) {
//     case 1:
//       return "info";
//     case 2:
//       return "primary";
//     case 3:
//       return "danger";
//     case 4:
//       return "warning";
//     default:
//       return "primary";
//   }
// };
export const getText = (ref) => {
  let text = "";

  const selected = ref.current.options[ref.current.selectedIndex];
  if (selected) {
    text = selected.text;
  }

  return text;
};

export const dateFormat = {
  LONG_DATE: "MM/DD/yyyy",
};
export const numberMaskOptions = {
  prefix: "",
  suffix: "",
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: ",",
  integerLimit: 7,
  allowNegative: false,
  allowLeadingZeroes: false,
};

export const currencyMaskOptions = {
  prefix: "₱",
  suffix: "",
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: ",",
  allowDecimal: true,
  decimalSymbol: ".",
  decimalLimit: 2, // how many digits allowed after the decimal
  integerLimit: 7, // limit length of integer numbers
  allowNegative: false,
  allowLeadingZeroes: false,
};

export const handleDate = (date) => {
  let parsedDate = new Date(Date.parse(date));
  return (
    parsedDate.getMonth() +
    1 +
    "/" +
    parsedDate.getUTCDate() +
    "/" +
    parsedDate.getFullYear()
  );
};

export const addressFormatter = (value) => {
  if (value === "" || value === null || value === undefined) return "";
  if (
    value.address1 === "" &&
    value.city === "" &&
    value.barangay === "" &&
    value.province === ""
  )
    return "No address provided";

  return (
    value.address1 +
    " " +
    value.barangay +
    " " +
    value.city +
    " " +
    value.province
  );
};

export const inputLabelFormat = (key) => {
	return key
		.replace(/([a-z])([A-Z\d]+)/g, '$1 $2')
		.trim()
		.split(' ')
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join(' ');
};

export const dateFormatter = (date) => {
  if (date === "0001-01-01T00:00:00") return "";
  if (date === null || date === undefined || date === "") return "";
  let parsedDate = moment(date).format("MM/DD/yyyy");
  return parsedDate;
};
export const dateTimeFormatter = (value) => {
  if (value === "0001-01-01T00:00:00") return "";
  if (value === null || value === undefined || value === "") return "";
  let parsedDate = moment(value).format("MM/DD/yyyy hh:mm A");
  return parsedDate;
};

export const dateFieldFormatter = (date) => {
  if (date === "" || date === null || date === undefined) return "";
  let parsedDate = moment(date).local().format("YYYY-MM-DD");
  return parsedDate;
};
export const timeFieldFormatter = (time) => {
  if (time === "" || time === null || time === undefined) return "";
  let parsedTime = moment(time).format("HH:mm");
  return parsedTime;
};

export const dateTimeFieldFormatter = (value) => {
  if (value === "" || value === null || value === undefined) return "";
  let parsedValue = moment(value).format("YYYY-MM-DDThh:mm");
  return parsedValue;
};

export const currencyFormat = (value) => {
  return new Intl.NumberFormat("en-PH", {
    style: "currency",
    currency: "PHP",
  }).format(value ? value : 0);
};

export const getSpecificPenaltyDays = (noOfDays) => {
  // const skipFirstMonth = noOfDays > 30 ? noOfDays - 29 : noOfDays;
  const daysInMonth = 30;
  const year = parseInt(noOfDays / 365);
  const month = parseInt((noOfDays % 365) / daysInMonth);
  const day = parseInt((noOfDays % 365) % daysInMonth);

  const yearString = year === 0 ? "" : `${year} year${year > 1 ? "s" : ""}`;
  const monthString =
    month === 0 ? "" : `${month} month${month > 1 ? "s" : ""}`;
  const dayString = day === 0 ? "" : `${day} day${day > 1 ? "s" : ""}`;

  return `${yearString} ${monthString} ${dayString}`;
};
export const nameFormatter = (value) => {
  if (value === "" || value === undefined || value === null) return "";
  if (value?.lastName === "" && value?.firstName === "") return "NO NAME";
  if (value?.lastName === null && value?.firstName === null) return "NO NAME";
  if (
    value.middleName !== "" ||
    value.middleName !== null ||
    value.middleName !== undefined
  ) {
    var suffix = value?.suffix === undefined ? "" : value.suffix;
    return (
      value.lastName +
      ", " +
      value.firstName +
      " " +
      value.middleName +
      " " +
      suffix
    );
  } else return value.lastName + ", " + value.firstName ?? "";
};

export const stringFormat = (value, pattern) => {
  if (value === "" || value === undefined) {
    return "";
  }
  var index = 0;
  var rawValue = value.toString();

  return pattern.replace(/#/g, (_) => rawValue[index++] ?? "");
};

export const apiErrorHandlers = function (error) {
  const status = error.response.status;
  const response = error.response;

  if (status === 400) {
    return {
      status: 400,
      succeeded: false,
      errors: response.data.errors,
    };
  } else if (status === 429){
    return {
      status: 429,
      succeeded: false,
      errors: response.data,
    };
  } else {
    return {
      status: status,
      succeeded: false,
      errorMessage: "Something went wrong, please try again.",
    };
  }
};

export const createOption = (label) => {
  if (label === "") return undefined;

  return {
    label,
    value: label,
  };
};
export const createOptions = (labels) => {
  const item = labels.map((item) => {
    return {
      label: item,
      value: item,
    };
  });
  return item;
};

export const overrideEnterKey = (key) => {
  if (key) {
  }
};
export const disabledEventPropagation = (key) => {
  if (key) {
    if (key.stopPropagation) {
      key.stopPropagation();
    } else if (window.event) {
      window.event.cancelBubble = true;
    }
  }
};

export const bookletNoFormatter = (ticketType, ticketNo, isBooklet = false) => {
  let bookletNo = "";
  if (ticketType === 1) {
    isBooklet
      ? (bookletNo =
          BOOKLET_NO_FORMATTER.HEALTH_PROTOCOL +
          stringFormat(ticketNo, "## ## #######"))
      : (bookletNo =
          BOOKLET_NO_FORMATTER.HEALTH_PROTOCOL +
          stringFormat(ticketNo, "## ## ####### ##"));
  } else if (ticketType === 2) {
    bookletNo = ticketNo;
  } else {
    return "Invalid Booklet No. Format.";
  }
  return bookletNo;
};

export const mapOptions = (label) => {
  if (label === "") return null;

  return {
    label,
    value: label,
  };
};

export const BOOKLET_NO_FORMATTER = {
  TRAFFIC: "QC",
  HEALTH_PROTOCOL: "OVR",
};

export const KEY_CODES = {
  COMMA: 188,
  ENTER: [10, 13],
};
export const KEYBOARD_SHORTCUTS = {
  YES_ACTION: ["Alt", "Y"],
  RETURN: ["Alt", "T"],
  SAVE_OR_UPDATE: ["Alt", "S"],
  SAVE_OR_UPDATE_NEW: ["Alt", "N"],
  SAVE_OR_UPDATE_CLOSE: ["Alt", "C"],
  SAVE_OR_UPDATE_REVIEW: ["Alt", "R"],
  SHOW_ADJUDICATE_FORM: ["Alt", "A"],
  PRINT: ["Alt", "P"],
};

export const HOTKEYS = {
  DASHBOARD: "alt+1",
  BOOKLET_RECEIVING: "alt+2",
  BOOKLET_ALLOCATION: "alt+3",
  TICKET_ENCODING: "alt+4",
  ASSESSMENT: "alt+5",
  PAYMENT: "alt+6",
  COLLECTION: "alt+7",
  AGENCY: "alt+8",
  OFFICER: "alt+9",
  SUPPLIER: "alt+0",
  VIOLATION: "alt+-",

  PRINT: "alt+p",
  RETURN: "alt+t",
  SAVE_UPDATE: "alt+s",
  SAVE_UPDATE_NEW: "alt+n",
  SAVE_UPDATE_CLOSE: "alt+c",
  SAVE_UPDATE_REVIEW: "alt+w",
  SHOW_ADJUDICATE: "alt+a",
  SHOW_GENERATE: "alt+g",
  REFRESH_TABLE: "alt+r",

  YES_ACTION: "alt+y",
};

export const OFFICER_CLASSIFICATION = [
  { id: 1, name: "Health Protocol Enforcers" },
  { id: 2, name: "Traffic Enforcers" },
];

export const ERROR_TYPES = {
  NOT_FOUND: "Record not found.",

  ASSESSMENT_MODULE: {
    ID: "Id",
    ORDER_OF_PAYMENT_NO: "AssessedTicket.OrderPaymentNo",
    TICKET_ID: "AssessedTicket.TicketId",
    TICKET_NO: "Ticket.TicketNo",
  },

  PAYMENT_MODULE: {
    ID: "Id",
    OR_NO: "Payment.ORNo",
    AMOUNT_PAID: "Payment.AmountPaid",
    ASSESSED_TICKET_ID: "Payment.AssessedTicketId",
    TICKET_NO: "TicketNo",
    ORDER_OF_PAYMENT_NO: "OrderPaymentNo",
  },

  TICKET_ENCODING_MODULE: {
    ID: "Id",
    TICKET_NO: "Ticket.TicketNo",
    INCIDENT_TIME: "Ticket.IncidentTime",
    ENFORCER_ID: "Ticket.EnforcerId",
    BOOKLET_ID: "Ticket.BookletId",
    TICKET: "Ticket",
  },

  COLLECTION_MODULE: {},
  OVR_TICKET_VS_COLLECTION_MODULE: {},

  //MAINTENANCE
  BOOKLET_RECEIVING_MODULE: {
    ID: "Id",
    BOOKLETS: "Booklets",
    BOOKLET_NO: "Booklet.BookletNo",
    SUPPLIER_ID: "Booklet.SupplierId",
  },

  BOOKLET_ALLOCATION_MODULE: {
    ID: "Id",
    ALLOCATED_BOOKLET: "AllocatedBooklet",
    BOOKLET_ID: "AllocatedBooklet.BookletId",
    ENFORCER_ID: "AllocatedBooklet.EnforcerId",
  },

  AREA_MODULE: {
    ID: "Id",
    AREA_CODE: "Area.Code",
  },
  ENFORCER_MODULE: {
    ID: "Id",
    ENFORCER: "Enforcer",
    DEPUTATION_NO: "Enforcer.DeputationNo",
    OFFICER_UNIT: "Enforcer.OfficerUnitId",
    AREA: "Enforcer.AreaId",
  },
  SUPPLIER_MODULE: {
    ID: "Id",
    SUPPLIER_CODE: "Supplier.Code",
    SUPPLIER_NAME: "Supplier.Name",
    SUPPLIER: "Supplier",
  },
  VIOLATION_MODULE: {
    ID: "Id",
    VIOLATION_CODE: "Violation.Code",
    VIOLATION_DETAILS: "Violation.ViolationDetails",
    VIOLATION: "Violation",
  },
  HOLIDAY_MODULE: {
    ID: "Id",
    HOLIDAY_NAME: "Holiday.Name",
    HOLIDAY_DESC: "Holiday.Description",
  },
};

export const MESSAGES = {
  CONFIRMATION_PROMPT: "Confirm Action",
  SAVE_PRINT_PROMPT:
    "You are about to save and print this record. Would you like to proceed?",
  UPDATE_PRINT_PROMPT:
    "You are about to update and print this record. Would you like to proceed?",
  SAVE_PROMPT: "You are about to save this record. Would you like to proceed?",
  SAVE_NEW_PROMPT:
    "You are about to save and reset this form. Would you like to proceed?",
  SAVE_CLOSE_PROMPT:
    "You are about to save and close this form. Would you like to proceed?",
  UPDATE_PROMPT:
    "You are about to update this record. Would you like to proceed?",
  UPDATE_NEW_PROMPT:
    "You are about to update and reset this form. Would you like to proceed?",
  UPDATE_CLOSE_PROMPT:
    "You are about to update and close this form. Would you like to proceed?",
  DELETE_PROMPT:
    "You are about to delete this record. Would you like to proceed?",
  RETURN_PROMPT:
    "You are about to mark this record as returned. Would you like to proceed?",
  SAVED_SUCCESSFULLY: "Record has been successfully saved.",
  UPDATED_SUCCESSFULLY: "Record has been successfully updated.",
  DELETED_SUCCESFULLY: "Record has been successfully deleted.",
  SAVE_FAILED: "Unable to save this record.",
  DELETE_FAILED: "Unable to delete this record. ",
  UPDATE_FAILED: "Unable to update this record.",

  DATA_IN_USED_DELETE_ERROR: "Unable to delete. Record is already in used.",
  DATA_IN_USED_UPDATE_ERROR: "Unable to update. Record is already in used.",

  DATA_ALREADY_EXISTING: "Record already exists.",
  DATA_NOT_EXISTING: "Record not found.",

  INVALID_DATA: "Parsing failure. Make sure you have a valid data",

  ASSESSMENT_MODULE: {
    TICKET_ALREADY_EXISTING:
      "Record did not update. Ovr No. and/or Order of Payment already exist.",
    ADJUDICATE_SUCCESSFUL: "Total amount has been successfully adjudicated.",
  },

  BOOKLET_ALLOCATION_MODULE: {
    ENFORCER_VALIDATION:
      "This enforcer is not yet registered, do you want to navigate to Enforcer List?",
  },
  BOOKLET_RECEIVING_MODULE: {
    NO_BOOKLET_VALIDATION: "Please provide atleast one booklet.",
    BOOKLET_ALREADY_EXIST: "Ovr No. and/or Order of Payment already exist.",
  },

  TICKET_ENCODING_FORM_MODULE: {
    BOOKLET_NOT_EXIST: "Ticket No. not found.",
    OFFICER_NOT_EXIST: "Officer not found.",
  },

  MAINTENANCE_MODULE: {
    AREA_MODULE: {},
    OFFICER_MODULE: {},
    SUPPLIER_MODULE: {},
    VIOLATION_MODULE: {},
  },
};

export const SOURCE = {
  ADMIN_PORTAL: 0,
  CITIZENS_PORTAL: 1,
};

export const PERMISSION = {
  BOOKLET_RECEIVING: {
    VIEW: "Permissions.BookletReceiving.View",
    CREATE: "Permissions.BookletReceiving.Create",
    EDIT: "Permissions.BookletReceiving.Edit",
    DELETE: "Permissions.BookletReceiving.Delete",
  },
  BOOKLET_ALLOCATION: {
    VIEW: "Permissions.BookletAllocation.View",
    CREATE: "Permissions.BookletAllocation.Create",
    EDIT: "Permissions.BookletAllocation.Edit",
    DELETE: "Permissions.BookletAllocation.Delete",
  },
  AREA: {
    VIEW: "Permissions.Area.View",
    CREATE: "Permissions.Area.Create",
    EDIT: "Permissions.Area.Edit",
    DELETE: "Permissions.Area.Delete",
  },
  HOLIDAY: {
    VIEW: "Permissions.Area.View",
    CREATE: "Permissions.Area.Create",
    EDIT: "Permissions.Area.Edit",
    DELETE: "Permissions.Area.Delete",
  },
  SUPPLIER: {
    VIEW: "Permissions.Supplier.View",
    CREATE: "Permissions.Supplier.Create",
    EDIT: "Permissions.Supplier.Edit",
    DELETE: "Permissions.Supplier.Delete",
  },
  ENFORCER: {
    VIEW: "Permissions.Enforcer.View",
    CREATE: "Permissions.Enforcer.Create",
    EDIT: "Permissions.Enforcer.Edit",
    DELETE: "Permissions.Enforcer.Delete",
  },
  VIOLATION: {
    VIEW: "Permissions.Violation.View",
    CREATE: "Permissions.Violation.Create",
    EDIT: "Permissions.Violation.Edit",
    DELETE: "Permissions.Violation.Delete",
  },
  TICKET_ENCODING: {
    VIEW: "Permissions.TicketEncoding.View",
    CREATE: "Permissions.TicketEncoding.Create",
    EDIT: "Permissions.TicketEncoding.Edit",
    DELETE: "Permissions.TicketEncoding.Delete",
    RESTORE: "Permissions.TicketEncoding.Restore",
  },
  ASSESSMENT: {
    VIEW: "Permissions.TicketAssessment.View",
    CREATE: "Permissions.TicketAssessment.Create",
    EDIT: "Permissions.TicketAssessment.Edit",
    DELETE: "Permissions.TicketAssessment.Delete",
    ADJUDICATE: "Permissions.TicketAssessment.Adjudicate"
  },
  PAYMENT: {
    VIEW: "Permissions.TicketPayment.View",
    CREATE: "Permissions.TicketPayment.Create",
    EDIT: "Permissions.TicketPayment.Edit",
    DELETE: "Permissions.TicketPayment.Delete",
  },
  USER: {
    VIEW: "Permissions.User.View",
    CREATE: "Permissions.User.Create",
    EDIT: "Permissions.User.Edit",
    DELETE: "Permissions.User.Delete",
  },
  ROLE: {
    VIEW: "Permissions.Role.View",
    CREATE: "Permissions.Role.Create",
    EDIT: "Permissions.Role.Edit",
    DELETE: "Permissions.Role.Delete",
  },
  COLLECTION: {
    VIEW: "Permissions.Collection.View",
    CREATE: "Permissions.Collection.Create",
    EDIT: "Permissions.Collection.Edit",
    DELETE: "Permissions.Collection.Delete",
  },
  LTO:{
    VIEW: "Permissions.LtoAccess.View",
    CREATE: "Permissions.LtoAccess.Create",
    EDIT: "Permissions.LtoAccess.Edit",
    DELETE: "Permissions.LtoAccess.Delete",
  }
};
export const WARN_INFO_HEALTH =
  "If you have any complaints/concerns regarding your city ordinance violation ticket, please do not pay yet. Instead, you may proceed to the Protest Adjudication Board (PAB), 3rd Floor DPOS Building, QC Hall Compound.<br /><br />You have five (5) working days from the date of apprehension to file a protest. Failure to file protest and to pay the fine within the given period shall cause the filing of a case with the City Prosecutor’s Office.";
export const WARN_INFO_TRAFFIC =
  "If you have any complaints regarding your traffic violation ticket, please do not pay yet. Instead, you may proceed to the Traffic Adjudication Board (TAB), 2nd Floor DPOS Building, QC Hall Compound.<br /> <br />You are given seven (7) days from the date of apprehension to file a complaint against your traffic violation ticket. Failure to do so within the prescribed period is tantamount to waiver of your rights to protest.";
